import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorPageComponent } from './error-page.component'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from '../../../shared-ui-refresh/button/button.module';
import { TranslateCompiler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';



@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        RouterModule,
        FormsModule,
        ButtonModule,
        TranslateModule.forChild({
        loader: provideTranslateHttpLoader({prefix:"./assets/i18n/", suffix: '.json?v=' + Date.now()}),

            compiler: {
                provide: TranslateCompiler,
                useClass: TranslateMessageFormatCompiler,
            }
        }),
    ],
    declarations: [
        ErrorPageComponent
    ],
    exports: [
        ErrorPageComponent
    ],

})

export class ErrorPageModule { }
